function SubHeader({ text }) {
    return (
        <h2 className='text-xl underline mb-2 font-bold font-mono'>
            {text}
        </h2>
    );
}

export default SubHeader;
